import { render, staticRenderFns } from "./settings-menu.vue?vue&type=template&id=67fc3965&scoped=true&"
import script from "./settings-menu.vue?vue&type=script&lang=js&"
export * from "./settings-menu.vue?vue&type=script&lang=js&"
import style0 from "./settings-menu.vue?vue&type=style&index=0&id=67fc3965&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67fc3965",
  null
  
)

export default component.exports